import { inject, IEventAggregator } from "aurelia";
import { CurrentRoute } from "../../current-route";
import { FormFieldChanged } from "../../messages/form-field-changed";
import { ApplicationService } from "../../services/application-service";
import { elementId } from "../../common/element-id";

@inject(Element, IEventAggregator, ApplicationService, CurrentRoute)
export class ApplicationDescriptionCustomAttribute {
  constructor(element, eventAggregator, applicationService, currentRoute) {
    this.element = element;
    this.eventAggregator = eventAggregator;
    this.applicationService = applicationService;
    this.currentRoute = currentRoute;
  }

  attached() {
    this.elementId = elementId(this.element);
    this.applicationId = this.currentRoute.params.id;
    this.subscription = this.eventAggregator.subscribe(
      FormFieldChanged,
      (message) => {
        this.onFormFieldChanged(message);
      }
    );
  }

  detaching() {
    this.subscription.dispose();
  }

  onFormFieldChanged(message) {
    if (message.elementId !== this.elementId || !this.applicationId) return;
    this.applicationService.setDescription(this.applicationId, message.value);
  }
}
